import { useNavigate } from 'react-router-dom';
import Constant from '../Utils/Constant';

const Error500Page = () => {
    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate('/');
    };

    const handleRetryClick = () => {
        window.location.reload();
    };

    return (
        <div className="error-500-page">
            <div className="error-500-content">
                {/* Titre principal */}
                <h1 className="error-500-title">500</h1>
                
                {/* Message d'erreur */}
                <p className="error-500-message">
                    {Constant.SERVER_ERROR_TITLE}
                </p>

                <p className="error-500-description">
                    {Constant.SERVER_ERROR_MESSAGE}
                </p>

                <p className="error-500-subtitle">
                    {Constant.SERVER_ERROR_DESCRIPTION}
                </p>

                {/* Boutons d'action */}
                <div className="error-500-actions">
                    <button 
                        className="btn btn-primary btn-lg me-3"
                        onClick={handleRetryClick}
                    >
                        <i className="fas fa-redo me-2"></i>
                        {Constant.TRY_AGAIN}
                    </button>
                    
                    <button 
                        className="btn btn-outline-light btn-lg"
                        onClick={handleHomeClick}
                    >
                        <i className="fas fa-home me-2"></i>
                        {Constant.BACK_TO_HOME}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Error500Page;